import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderState } from '../doqfy-components/loader/loader.component';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private loaderSubject = new Subject<LoaderState>();
  isLoading = new Subject<boolean>();

  loaderState = this.loaderSubject.asObservable();

  constructor() {}

  show() {
      this.loaderSubject.next({ show: true } as LoaderState);
     
  }

  hide() {
      this.loaderSubject.next({ show: false } as LoaderState);
  }
}
